<script lang="ts">
  export let message: string;
  export let onDismiss: () => void;
</script>

<div class="flex items-center gap-2 border-b border-destructive/20 bg-destructive/10 px-4 py-2 text-sm text-destructive">
  <i class="fa-solid fa-circle-exclamation shrink-0"></i>
  <span class="flex-1">{message}</span>
  <button class="shrink-0 rounded p-1 text-destructive/70 hover:bg-destructive/10 hover:text-destructive" on:click={onDismiss} title="Dismiss">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>
